import { Accordion } from "flowbite-react"

const MernStackFAQ: React.FC = () => {
  return (
    <>
      <Accordion>
        <Accordion.Panel>
          <Accordion.Title as="h3" className="accordion-title">
            What is MERN Stack?
          </Accordion.Title>
          <Accordion.Content className="accordion-border">
            <div className="fs-md mb-0 text-secondary">
              MERN Stack is a full-stack JavaScript framework comprising four
              key technologies: MongoDB, Express.js, React.js, and Node.js.
              MongoDB is a NoSQL database, Express.js facilitates the
              development of web applications with Node.js, React.js enables the
              creation of interactive user interfaces, and Node.js serves as the
              runtime environment for server-side scripting. Together, these
              components form a powerful and efficient framework for building
              modern, scalable web applications, offering flexibility,
              performance, and ease of development throughout the entire
              development process.
            </div>
          </Accordion.Content>
        </Accordion.Panel>
        <Accordion.Panel>
          <Accordion.Title as="h3" className="accordion-title">
            Why should I choose the MERN stack for my project?
          </Accordion.Title>
          <Accordion.Content className="accordion-border">
            <div className="fs-md mb-0 text-secondary">
              Choosing the MERN stack for your project offers numerous
              advantages, including a unified JavaScript ecosystem for both
              frontend and backend development, which streamlines development
              and enhances code reusability. The MERN stack also boasts robust
              community support and extensive documentation, making it easier to
              troubleshoot issues and find solutions. Additionally, its
              components—MongoDB, Express.js, React.js, and Node.js—offer
              scalability, flexibility, and performance, making it ideal for
              building modern and dynamic web applications capable of handling
              complex requirements and high user loads.
            </div>
          </Accordion.Content>
        </Accordion.Panel>
        <Accordion.Panel>
          <Accordion.Title as="h3" className="accordion-title">
            What tools and technologies are commonly used in MERN stack
            development?
          </Accordion.Title>
          <Accordion.Content className="accordion-border">
            <div className="fs-md mb-0 text-secondary">
              These are the tools and technologies commonly used in MERN stack
              development:
              <br />
              <ul className="list mt-3 mb-3">
                <li>MongoDB: NoSQL database</li>
                <li>Express.js: Web application framework</li>
                <li>React.js: Frontend library</li>
                <li>Node.js: Runtime environment</li>
                <li>npm: Package manager</li>
                <li>Git: Version control system</li>
                <li>VS Code: Source code editor</li>
                <li>Webpack: Module bundler</li>
                <li>Babel: JavaScript compiler</li>
                <li>ESLint: A code analysis tool</li>
              </ul>
            </div>
          </Accordion.Content>
        </Accordion.Panel>
        <Accordion.Panel>
          <Accordion.Title as="h3" className="accordion-title">
            What is the cost of developing a MERN stack application?
          </Accordion.Title>
          <Accordion.Content className="accordion-border">
            <div className="fs-md mb-0 text-secondary">
              The cost of developing a MERN stack application can vary widely,
              with hourly rates for developers typically ranging from $20 to $50
              or more, depending on their expertise, location, and project
              requirements. For a basic MERN stack application, the development
              cost can start from around $5,000 to $10,000 for simpler projects,
              while more complex and feature-rich applications may require
              budgets upwards of $20,000 to $100,000 or more. It&apos;s crucial
              to consider factors like project scope, desired features, design
              complexity, and ongoing maintenance when estimating the total cost
              of development.
            </div>
          </Accordion.Content>
        </Accordion.Panel>
      </Accordion>
    </>
  )
}

export default MernStackFAQ
